import { render, staticRenderFns } from "./THG.vue?vue&type=template&id=8e71e138"
import script from "./THG.vue?vue&type=script&setup=true&lang=ts"
export * from "./THG.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports